import { __awaiter, __assign, __generator } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { refreshToken } from '@cheetahdigital/cesauth-core-lib';
import { Layout, enums } from '@cheetahdigital/console-kit-cx';
import { useCallback } from 'react';
import { useAppContext } from '../../../contexts/AppProvider.js';
import { useBusinessUnitChangeModalContext } from '../../../contexts/BusinessUnitChangeModalProvider.js';
import { getChangeBusinessUnitRedirectUrl } from '../../../contexts/ChangeBusinessUnitModalProvider.js';
import { useOrganizationContext } from '../../../contexts/OrganizationProvider.js';
import { useTranslation } from '../../../locales/i18n.js';
import userService from '../../../services/user.service.js';
import '../../../node_modules/classnames/index.js';
import Modal from '../../../shared/components/Modal/index.js';
import 'semantic-ui-react';
import 'react-dom';
import Button from '../../../shared/elements/Button/index.js';
import Buttons from '../../../shared/elements/Buttons/index.js';
import Label from '../../../shared/elements/Label/index.js';
import Headline from '../../../shared/elements/Headline/index.js';
import { Trans } from '../../../node_modules/react-i18next/dist/es/Trans.js';

var BusinessUnitChangeModal = function (_a) {
    var _b = _a.isActive, isActive = _b === void 0 ? false : _b, businessUnit = _a.businessUnit;
    var t = useTranslation()[0];
    var organization = useOrganizationContext().organization;
    var _c = useAppContext().platformId, platformId = _c === void 0 ? "" : _c;
    var _d = useBusinessUnitChangeModalContext(), setIsShowBusinessUnitChangeModal = _d[1];
    var handleYes = useCallback(function () {
        if (!businessUnit) {
            return;
        }
        var redirectUrl = getChangeBusinessUnitRedirectUrl({
            platformId: platformId,
            buId: businessUnit.buId
        });
        window.location.href = redirectUrl;
    }, [businessUnit, platformId]);
    var handleNo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userService.switchBusinessUnit({
                        buId: organization.buId,
                        platformId: platformId
                    })];
                case 1:
                    _a.sent();
                    refreshToken();
                    setIsShowBusinessUnitChangeModal(false);
                    return [2 /*return*/];
            }
        });
    }); }, [organization.buId, platformId, setIsShowBusinessUnitChangeModal]);
    return (jsx(Fragment, { children: jsx(Modal, __assign({ isActive: isActive, onClose: handleNo }, { children: jsxs(Layout, { children: [jsx(Layout.Row, { children: jsx(Headline, __assign({ size: "huge", isUppercase: false, isGapless: true }, { children: t("business-unit-has-changed") }), void 0) }, void 0), jsx(Layout.Row, { children: jsx(Layout.Column, { children: jsx(Label, { children: jsx(Trans, { i18nKey: "you-already-switched-to", t: t, values: { name: businessUnit === null || businessUnit === void 0 ? void 0 : businessUnit.buName }, components: { bold: jsx("strong", {}, void 0) } }, void 0) }, void 0) }, void 0) }, void 0), jsx(Layout.Row, { children: jsx(Layout.Column, __assign({ textAlign: enums.textAlignments.RIGHT }, { children: jsxs(Buttons, { children: [jsx(Button, __assign({ isSolid: false, onClick: handleNo }, { children: t("no") }), void 0), jsx(Button, __assign({ isSolid: true, onClick: handleYes }, { children: t("yes") }), void 0)] }, void 0) }), void 0) }, void 0)] }, void 0) }), void 0) }, void 0));
};

export { BusinessUnitChangeModal as default };
